export default {
  namespaced: true,
  state: {
    name: 'admin',
    routeName: '',
    beforeName: '',
    user: {}
  },
  mutations: {
    saveNowRoute(state, name) {
      state.routeName = name
    },
    saveLoginBeforeName(state, name) {
      state.beforeName = name
    },
    setUser(state, user) {
      state.user = user
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/userStore/modules/user.js